import { MutationConfig } from '@nohara-dxdev/react-core';
import { useScopeIds } from '@nohara-dxdev/react-oidc';
import { useMutation, useQueryClient } from '@tanstack/react-query';

import { api } from '@/lib/api-client';

import { getItemsQueryKey } from './get-items';

export const deleteItem = async (
  orgId: string,
  projectId: string,
  itemId: string,
): Promise<void> => {
  await api.delete(`/orgs/${orgId}/projects/${projectId}/items/${itemId}`);
};

interface UseDeleteItemOptions {
  mutationConfig?: MutationConfig<(itemId: string) => Promise<void>>;
}

export const useDeleteItem = ({ mutationConfig }: UseDeleteItemOptions = {}) => {
  const queryClient = useQueryClient();
  const { orgId, projectId } = useScopeIds('org', 'project');
  const { onSuccess, onError, ...restConfig } = mutationConfig ?? {};
  return useMutation({
    onSuccess: (...args) => {
      // Invalidate and refetch items list
      void queryClient.invalidateQueries({
        queryKey: getItemsQueryKey(orgId, projectId),
      });
      onSuccess?.(...args);
    },
    onError: (...args) => {
      onError?.(...args);
    },
    ...restConfig,
    mutationFn: (itemId: string) => deleteItem(orgId, projectId, itemId),
  });
};
